// extracted by mini-css-extract-plugin
export default {"navbar":"Header_navbar__5ObXw"};